import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';

export const NAHLED_SIRKA = 1080;
export const NAHLED_VYSKA = 1920;

/** Měřítko rámečku 1080 × 1920: na výšku okna, a když by přetekl do šířky (telefon), na šířku. */
export const meritkoNahledu = (oknoSirka: number, oknoVyska: number): number =>
    Math.min(oknoVyska / NAHLED_VYSKA, oknoSirka / NAHLED_SIRKA);

// Náhled kiosku na výšku z adminu (?orientace=vyska): wrapper dostane pevný rámeček 1080 × 1920
// a zmenší se přes transform: scale. offset*/ResizeObserver/Leaflet pracují v nezmenšených px,
// FitHeightBox přepočítává měřítko sám. Myší se náhled neovládá.
export const RamecekNahleduNaVysku: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [meritko, setMeritko] = useState(() => meritkoNahledu(window.innerWidth, window.innerHeight));
    useEffect(() => {
        // Událost resize chodí v dávkách; měřítko se přepočítá nejvýš jednou za frame.
        let frame = 0;
        const zmena = () => {
            if (frame) return;
            frame = window.requestAnimationFrame(() => {
                frame = 0;
                setMeritko(meritkoNahledu(window.innerWidth, window.innerHeight));
            });
        };
        window.addEventListener('resize', zmena);
        return () => {
            window.removeEventListener('resize', zmena);
            if (frame) window.cancelAnimationFrame(frame);
        };
    }, []);
    return (
        <Box data-testid="ramecek-nahledu-vyska" sx={{
            width: '100vw', height: '100vh', bgcolor: '#111',
            display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden',
        }}>
            <Box sx={{
                width: `${NAHLED_SIRKA * meritko}px`, height: `${NAHLED_VYSKA * meritko}px`,
                position: 'relative', overflow: 'hidden', flex: 'none',
            }}>
                <Box data-testid="ramecek-nahledu-obsah" data-meritko={meritko.toFixed(4)} sx={{
                    position: 'absolute', top: 0, left: 0,
                    width: `${NAHLED_SIRKA}px`, height: `${NAHLED_VYSKA}px`,
                    transform: `scale(${meritko})`, transformOrigin: '0 0',
                }}>
                    {children}
                </Box>
            </Box>
        </Box>
    );
};
